import { Component, NgZone, TemplateRef, ViewChild } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { PATTERNS } from '../../shared/constants/patterns.constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../../shared/services/api.service';

@Component({
  selector: 'app-country',
  templateUrl: './country.component.html',
  standalone: false,
  styleUrls: ['./country.component.scss']
})
export class CountryComponent {

  count = 0;
  dataObj: any = {};
  modalRef: any;
  gridApi: any;
  apiUrl: any;
  // content: any;
  type = 'country';
  pattern = PATTERNS;
  currencies: any;
  @ViewChild('content') content!: TemplateRef<any>;

  columnDefs: ColDef[] = [
        {
      headerName: 'Action',
      field: 'action',
      width: 80,
      cellRenderer: (params: any) => {
        const button = document.createElement('button');
        button.classList.add('btn', 'btn-sm', 'btn-primary', 'active', 'rounded-pill');
        button.innerHTML = '<i class="bi bi-eye-fill"></i>';
        button.addEventListener('click', () => this.onEdit(params));
        return button;
      },
    },
    {
      headerName: 'Name',
      field: 'displayName',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Dialing Code',
      field: 'dialingCode',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Currency',
      field: 'currency.name',
      editable: false,
      filter: true,
    },
    {
      headerName: 'Status',
      field: 'status',
      editable: false,
      filter: true,
    },

  ];

  gridOptions: any = {
    paginationPageSize: 15,
    cacheBlockSize: 15,
    pagination: true,
    rowModelType: 'infinite',
    paginationPageSizeSelector: [15, 20, 50, 100],
    datasource: this.createDataSource(),
    rowSelection: 'multiple',
    context: {
      componentParent: this,
    },
  };


  constructor(
    private _modal: NgbModal,
    private _api: ApiService,
    private zone: NgZone
  ) { }

  ngOnInit(): void {
    const vm = this;
    vm.getCurrencies();
  }

  onGridReady(params: any) {
    const vm = this;
    vm.gridApi = params.api;
    if (vm.gridApi) {
      vm.gridApi = params.api;
      vm.gridApi.sizeColumnsToFit();
    }
  }

  refreshGrid() {
    const vm = this;
    if (vm.gridApi) {
      vm.gridApi.refreshInfiniteCache();
    }
  }

  createDataSource() {
    const vm = this;
    const datasource = {
      getRows: (params: any) => {
        const startRow = params.startRow;

        const request = {
          _page: startRow / vm.gridOptions.paginationPageSize + 1,
          _limit: vm.gridOptions.paginationPageSize,
        };
        vm.apiUrl = '/partners/auth/get-data?type=' + vm.type + '&_page=' + request._page + '&_limit=' + request._limit;
        const filterData = vm.gridApi.getFilterModel();
        Object.keys(filterData).forEach(k => {
          if (k && filterData[k]) {
            vm.apiUrl = vm.apiUrl + '&' + k + '_like=' + filterData[k].filter;
          }
        });
        vm._api.getData(vm.apiUrl).subscribe((res: any) => {
          if (res && !res.error) {
            vm.count = res.count;
            params.successCallback(res.data, res.count);
            //vm.gridApi.sizeColumnsToFit();
          } else {
            params.failCallback();
          }
        });
      },
    };
    return datasource;
  }

  getCurrencies() {
    const vm = this;
    const type = 'currency'
    const apiUrl = '/partners/auth/get-data?type=' + type + '&_limit=500';
    vm._api.getData(apiUrl).subscribe((res: any) => {
      if (res && !res.error) {
        vm.currencies = res.data;
      }
    });
  }

  addNew() {
    const vm = this;
    vm.dataObj = {};
    //this.content = content;
    vm.modalRef = vm._modal.open(this.content, { backdrop: 'static', size: 'lg' });
  }


  onEdit(data: any) {
    const vm = this;
    vm.zone.run(() => {
      vm.dataObj = data.data;
      if (vm.dataObj.currency && vm.dataObj.currency._id) {
        vm.dataObj.currency = vm.dataObj.currency._id;
      }
      vm.modalRef = vm._modal.open(vm.content, { backdrop: 'static', size: 'lg' });
    });
  }

  setContent(c: any) {
    this.content = c;
  }

  onSubmit(flag: any) {
    this.dataObj['type'] = this.type;
    this.dataObj['id'] = 123;
    this.dataObj['is_recipient'] = true;
    this.dataObj['is_origination'] = true;
    const apiUrl = this.dataObj._id ? '/partners/auth/edit-data' : '/partners/auth/new-data';
    this._api.postData(apiUrl, this.dataObj).subscribe((res: any) => {
      if (res && !res.error) {
        this.onClose();
        this.gridApi.refreshInfiniteCache();
      }
    });
  }

  onClose() {
    this.modalRef.close();
  }

}
